import React from "react";
import { Collapse } from "@mui/material";
import { StaticImage } from "gatsby-plugin-image";

const HighIncome = ({
  phoneNumber = "800-971-4060",
  heroSectionTitle,
  heroSectionDescription,
}) => {
  const [showText, setShowText] = React.useState(false);
  const points = [
    "Exclusive Program for Texas Residents",
    "Specialists for resolving $50K to $300K+",
    "Free No-Obligation Consultation",
    "Receive up to 40% Lower Fees*",
  ];
  const defaultDesc =
    "Debt Redemption offers specialized debt relief solutions exclusively for Texas residents, focusing on high-income earners struggling with significant debt burdens. Our expert team provides tailored services in debt settlement, debt consolidation, and credit counseling, helping you manage and reduce high amounts of credit card debt and other financial liabilities. If you’re considering bankruptcy alternatives, we are here to guide you toward a future free from overwhelming debt. Take control of your finances with Debt Redemption – Texas’s trusted partner for debt relief solutions.";

  return (
    <React.Fragment>
      <div className="tab:hidden pb-6">
        <div className="bg-[#023c6e] py-7 mb-5">
          <div className="container">
            <p className="text-white font-semibold text-2xl">
              Debt Relief Program for{" "}
              <span className="text-custom-orange border-b-[3px]">
                higher-income
              </span>{" "}
              Earners
            </p>
          </div>
        </div>
        <div className="container">
          <div className="text-[#023c6e] flex flex-col gap-2 font-semibold text-xl mb-6">
            {points.map((point, index) => (
              <p className="flex items-center" key={index}>
                <img
                  src="/svgs/icons/check.svg"
                  className="me-2"
                  width={18}
                  height={14}
                  alt="Check"
                />{" "}
                {point}
              </p>
            ))}
          </div>
        </div>
      </div>
      <div className="bg-custom-primary py-8 max-tab:hidden">
        <div className="container">
          <h2 className="text-white font-medium text-center xl:leading-[45px] text-2xl sm:text-4xl">
            Experienced Texas Debt Specialists are available for{" "}
            <span className="text-custom-orange">higher-income</span> earners
            with 50K to 300K+ in credit cards and personal loans.
          </h2>
          <div className="mt-6 flex flex-col items-center justify-center sm:hidden">
            <p className="text-white text-md mb-2">
              Are you a{" "}
              <span className="text-custom-orange">higher-income</span> earner?
            </p>
            <a
              href={`tel:${phoneNumber.replaceAll("-", "")}`}
              className="bg-custom-orange font-bold rounded-xl uppercase text-white text-4xl px-4 py-1"
            >
              call now
            </a>
          </div>
        </div>
      </div>
      {heroSectionTitle && (
        <div className="bg-white max-md:pb-3 max-md:pt-10">
          <div className="container">
            <div className="grid md:grid-cols-[55%_45%] gap-2 place-items-center">
              <div className="text-custom-primary">
                {heroSectionTitle && (
                  <h1 className="text-4xl lg:text-5xl mb-4 font-bold">
                    {heroSectionTitle}
                  </h1>
                )}
                <div className="max-sm:hidden">
                  <p className="font-normal text-justify">
                    {heroSectionDescription
                      ? heroSectionDescription
                      : defaultDesc}
                  </p>
                </div>
                <div className="sm:hidden">
                  <Collapse in={showText} collapsedSize={70}>
                    <p className="font-normal text-justify">
                      {heroSectionDescription
                        ? heroSectionDescription
                        : defaultDesc}
                    </p>
                  </Collapse>
                  {!showText && (
                    <button
                      className="font-bold underline"
                      onClick={() => setShowText(true)}
                    >
                      See more
                    </button>
                  )}
                </div>
              </div>
              <div>
                <StaticImage
                  src="https://adc-dr-assets.s3.amazonaws.com/debtredemption/images/sapiens.webp"
                  className="w-full h-full"
                  alt="Sapiens"
                />
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="bg-white p-6 max-sm:hidden border-t">
        <div className="flex justify-center max-tab:flex-col items-center gap-4">
          <div>
            <p className="text-custom-primary text-2xl">
              Are you a{" "}
              <span className="text-custom-orange">higher-income</span> earner?
            </p>
            <a href={`tel:${phoneNumber.replaceAll("-", "")}`}>
              <h5 className="text-custom-primary uppercase font-bold text-5xl text-center">
                call now
              </h5>
            </a>
          </div>
          <a
            href={`tel:${phoneNumber.replaceAll("-", "")}`}
            className="bg-custom-primary font-bold rounded-xl text-white text-5xl px-2 py-1"
          >
            {phoneNumber}
          </a>
        </div>
      </div>
    </React.Fragment>
  );
};

export default HighIncome;
